import { useEffect, useRef } from 'react';
import { useCallback, useMemo, useState } from 'react';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import { IoIosArrowBack } from 'react-icons/io';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as Yup from 'yup';

import { Input, Layout } from '~/components';
import { useAuth } from '~/hooks/auth';
import api from '~/services/api';
import getValidationErrors from '~/utils/getValidationErrors';

import {
  Header,
  HeaderWrapper,
  HeaderLabel,
  SaveButton,
  Container,
  FieldSet,
  InputLabel,
  Wrapper,
  RadioButton,
} from './styles';

type RequestData = {
  description: string;
};

function ExEditor() {
  const { goBack } = useHistory();
  const { user } = useAuth();
  const formRef = useRef<FormHandles>(null);

  const [loading, setLoading] = useState(false);
  const [selectedBox, setSelectedBox] = useState<string>('');
  const [checkBoxOptions, setCheckBoxOptions] = useState<string[]>([]);

  // Load exercises segments to fill checkbox options
  const loadSegments = useCallback(async () => {
    const { data } = await api.get<RequestData[]>(`training-stores`, {
      params: {
        segment: `SEGMENTO`,
      },
    });

    const mappedData = data.map((segment) => segment.description);

    setCheckBoxOptions(mappedData);
    setSelectedBox(mappedData[0]);
  }, []);

  useEffect(() => {
    loadSegments();
  }, [loadSegments]);

  const CheckBox = useMemo(
    () =>
      checkBoxOptions.map((item) => (
        <RadioButton
          key={item}
          isSelected={selectedBox === item}
          onClick={() => setSelectedBox(item)}
        >
          <div className="radio">
            <div className="filled" />
          </div>

          <p>{item}</p>
        </RadioButton>
      )),
    [checkBoxOptions, selectedBox],
  );

  const handleSubmit = useCallback(
    async (data) => {
      setLoading(true);

      const formData = {
        ...data,
        professional_id: user.professional.id,
        muscle_segment: checkBoxOptions.filter(
          (item) => item === selectedBox,
        )[0],
      };

      const schema = Yup.object().shape({
        name: Yup.string().required('O campo é obrigatório!'),
      });

      try {
        await schema.validate(formData, { abortEarly: false });

        await api.post(`ex-editors`, formData);

        toast.success('Exercício cadastrado com sucesso!');

        goBack();
      } catch (err) {
        console.log(err);
        setLoading(false);

        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);

          formRef.current?.setErrors(errors);
        }

        toast.error('Erro ao cadastrar o exercício!');
      }
    },
    [checkBoxOptions, selectedBox, goBack, user],
  );

  return (
    <Layout title="I.LAB">
      <Header>
        <HeaderWrapper onClick={() => goBack()}>
          <IoIosArrowBack color="#FFDF22" size={24} />
          <HeaderLabel>Ex - Editor</HeaderLabel>
        </HeaderWrapper>

        <SaveButton
          disabled={loading}
          onClick={() => formRef.current?.submitForm()}
        >
          Salvar
        </SaveButton>
      </Header>

      <Container>
        <Form ref={formRef} onSubmit={handleSubmit}>
          <FieldSet>
            <InputLabel>Nome:</InputLabel>
            <Input
              name="name"
              fontSize="1.5rem"
              containerStyle={{
                width: '32rem',
                height: '3.5rem',
                padding: '0 1.8rem',
              }}
            />
          </FieldSet>

          <FieldSet>
            <InputLabel>Segmento muscular:</InputLabel>

            <Wrapper>{CheckBox}</Wrapper>
          </FieldSet>
        </Form>
      </Container>
    </Layout>
  );
}

export default ExEditor;
